/**
 * CompanyDashboardAddExistingObjectivesPopup
 *
 * Dialog allowing users to search and select an existing Objective to link.
 * Filters out objectives already selected upstream. Uses a simple text search
 * and returns the chosen objective via setSelectedObjectiveData, then closes.
 */
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { SearchInputComponent } from "../../../common/components";
import CompanyDashboardAllObjectiveCard from "./company-dashboard-add-existing-objectives-popup-card/company-dashboard-add-existing-objectives-popup-card";
import { getProgressColor } from "../company-dashboard-utils";
import dayjs from "dayjs";
import { getAllObjectives } from "../../../api/objectives";
import CloseIcon from "../../../assets/icons/closeIcon.svg";
import "./company-dashboard-add-existing-objectives-popup.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const CompanyDashboardAddExistingObjectivesPopup: any = (props: any) => {
  const {
    isOpenAddPopup,
    onCancel,
    setLoading,
    setSelectedObjectiveData,
    selectedObjectiveData,
  } = props;
  const [objectivesData, setObjectivesData] = useState<any[]>([]);
  const [sortedObjectivesData, setSortedObjectivesData] = useState<any[]>([]);
  const fetchObjectives = async () => {
    setLoading(true);
    try {
      const response = await getAllObjectives({});
      const filteredObjectives = response.data.data.filter((obj: any) => {
        return !selectedObjectiveData?.find(
          (selected: any) => selected.objectiveId === obj.objectiveId,
        );
      });

      setObjectivesData(filteredObjectives);
      setSortedObjectivesData(filteredObjectives);
      setTimeout(() => setLoading(false), 0);
    } catch {
      setObjectivesData([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchObjectives();
  }, []);

  const validationSchema = () => Yup.object().shape({});
  return (
    <Dialog
      open={isOpenAddPopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        onCancel();
      }}
      className={`company-dashboard-add-existing-objectives-popup-container `}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="header-wrapper">
          <div className="header-wrapper-text">Add Existing Objectives</div>
          <div className="image-wrapper">
            <button
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
              onClick={onCancel}
            >
              <img
                alt="Close"
                style={{ cursor: "pointer" }}
                src={CloseIcon}
                className="close-icon"
              />
            </button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{}}
          validationSchema={validationSchema}
          validateOnChange={true}
          enableReinitialize={true}
          onSubmit={() => {}}
        >
          {() => (
            <Form>
              <OverlayScrollbarsComponent
                style={{ maxHeight: "500px" }}
                options={{
                  scrollbars: {
                    theme: "os-theme-dark",
                    autoHide: "scroll",
                    autoHideDelay: 400,
                  },
                }}
              >
                <div
                  className={`company-dashboard-add-existing-objectives-popup-container-search `}
                >
                  <SearchInputComponent
                    placeholder="Search Objectives"
                    onSearch={(value: string) => {
                      const filteredObjectives = objectivesData.filter((obj) =>
                        obj.objectiveName
                          .toLowerCase()
                          .includes(value.toLowerCase()),
                      );
                      setSortedObjectivesData(filteredObjectives);
                      if (value === "") {
                        setSortedObjectivesData(objectivesData);
                      }
                    }}
                    isReset={false}
                    ref={null}
                  />
                </div>
                {sortedObjectivesData?.length > 0 ? (
                  sortedObjectivesData?.map((item: any) => {
                    return (
                      <CompanyDashboardAllObjectiveCard
                        key={item.id}
                        onClickCard={() => {
                          setSelectedObjectiveData([
                            ...selectedObjectiveData,
                            item,
                          ]);
                          onCancel();
                        }}
                        mainLabel={item?.objectiveName}
                        progressValue={item.progress}
                        subLabel={`Last Updated ${
                          item?.lastUpdated
                            ? dayjs(item.lastUpdated).format("MM-DD-YYYY")
                            : "-"
                        }`}
                        keyResultsCount={item.keyResultsCount || 0}
                        initiativesCount={item.initiativesCount || 0}
                        borderColor={getProgressColor(item.status).mainColor}
                        lightBorderColor={
                          getProgressColor(item.status).lightColor
                        }
                      />
                    );
                  })
                ) : (
                  <div className="company-dashboard-no-objective">
                    No Data Found
                  </div>
                )}
                <div></div>
              </OverlayScrollbarsComponent>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardAddExistingObjectivesPopup;
